import { render, staticRenderFns } from "./title-actions.vue?vue&type=template&id=c938554c&"
import script from "./title-actions.vue?vue&type=script&lang=ts&"
export * from "./title-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c938554c')) {
      api.createRecord('c938554c', component.options)
    } else {
      api.reload('c938554c', component.options)
    }
    module.hot.accept("./title-actions.vue?vue&type=template&id=c938554c&", function () {
      api.rerender('c938554c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/title/title-actions.vue"
export default component.exports